import { gql } from 'apollo-boost';


export const ILT_QUERY = gql`
    query instructorLedTraining($iltID: UUID!) {
        instructorLedTraining(iltID: $iltID) {
            id
            companyId
            defaultSessionName
            sessions {
                id
                instructorLedTrainingId
                locales {
                    name
                    locale
                }
                status
                maxSeats
                filledSeats
                meetingUrl
                registrationUrl
                registrationOpenAt
                registrationCloseAt
                sessionStartAt
                sessionEndAt
                createdAt
                updatedAt
                canceledAt
                instructors {
                    id
                    name
                    description
                    title
                    emailAddress
                }
                address {
                    id
                    label
                    name
                    addressLine1
                    addressLine2
                    locality
                    administrativeArea
                    postalCode
                    country {
                        id,
                        code
                        name
                    }
                }
            }
            createdAt
            updatedAt
        }
    }
`;


export const ILT_REGISTER_MUTATION = gql`
    mutation createSessionRegistration($input: CreateSessionRegistrationInput!) {
        createSessionRegistration(input: $input) {
            id
            companyId
            sessionId
            personId
            createdAt
        }
    }`;


export const ILT_UNREGISTER_MUTATION = gql`
    mutation deleteSessionRegistration($iltID: UUID!, $sessionID: UUID!, $registrationID: UUID!) {
        deleteSessionRegistration(iltID: $iltID, sessionID: $sessionID, registrationID: $registrationID) {
            success
            message
        }
    }`;


export const COMPLETE_SESSION_MUTATION = gql`
    mutation createSessionCompletion($input: CreateSessionCompletionInput!) {
        createSessionCompletion(input: $input) {
                id
                companyId
                sessionRegistrationId
                completionCode
                createdAt
        }
    }`;

export const ILT_REGISTRATION_QUERY = gql`
    query getSessionRegistrationByPerson($iltID: UUID!, $personID: UUID!) {
        getSessionRegistrationByPerson(iltID: $iltID, personID: $personID) {
            sessionRegistration {
                id
                companyId
                sessionId
                personId
                createdAt
            }
            sessionCompletion {
                id
                companyId
                sessionRegistrationId
                completionCode
                createdAt
            }
        }
    }
    `;